import { forwardRef } from "react";
import { clsx } from "clsx";
import classes from "./Card.module.scss";
import { CardProps } from "./CardProps";

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { children, className, bgImage, ...props },
  ref,
) {
  const hasImage = !!bgImage;
  return (
    <div
      ref={ref}
      className={clsx(classes.card, className, hasImage && classes.hasImage)}
      style={{
        backgroundImage: bgImage ? `url(${bgImage})` : undefined,
      }}
      {...props}
    >
      {children}
    </div>
  );
});
